import { useFormContext } from "react-hook-form"
import { convertReactSelectObjectToValue } from "../../../../../../utils/reporting/config"

const SelectColumns = [
    {
        Header: 'Source.Column',
        accessor: `sourceColumn`,
        Cell: ({ cell, value: initialValue, row: { index }, column: { id, accessor }, }) => {
            const { control, register } = useFormContext()
            const formattedValue = initialValue && `${initialValue.split('.')[0]}.${initialValue.split('.')[1]}`
            return <>
                {initialValue && <span>{initialValue.split('.')[0]}.<b>{initialValue.split('.')[1]}</b></span>}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].sourceColumn`} ref={register()} className={`collapsedField`} defaultValue={formattedValue} />
            </>
        },
    },
    {
        Header: 'Column Type',
        accessor: 'dataType',
        Cell: ({ cell, value: initialValue, row: { index }, column: { id, accessor }, }) => {
            const { control, register } = useFormContext()
            return <>
                {initialValue}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].dataType`} ref={register()} className={`collapsedField`} defaultValue={initialValue} />
            </>
        },
    },
    {
        Header: "Column Alias",
        accessor: "alias",
        Cell: ({ cell, value: initialValue, row: { index }, column: { id, accessor } }) => {
            const { register, watch, control } = useFormContext()
            return (<>
                {convertReactSelectObjectToValue(initialValue)}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].alias`} ref={register()} className={`collapsedField`} defaultValue={convertReactSelectObjectToValue(initialValue)} />
            </>)
        }
    },
    {
        Header: 'Translate Function',
        accessor: 'function',
        Cell: ({ cell, value: initialValue, row: { index }, column: { id, accessor } }) => {
            const { register, watch, control } = useFormContext()
            return (<>
                {convertReactSelectObjectToValue(initialValue)}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].function`} ref={register()} className={`collapsedField`} defaultValue={convertReactSelectObjectToValue(initialValue)} />
            </>)
        }
    },
    {
        Header: 'Translate Argument',
        accessor: 'functionArgument',
        Cell: ({ cell, value: initialValue, row: { index }, column: { id, accessor } }) => {
            const { register, watch, control } = useFormContext()
            return (<>
                {convertReactSelectObjectToValue(initialValue)}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].functionArgument`} ref={register()} className={`collapsedField`} defaultValue={convertReactSelectObjectToValue(initialValue)} />
            </>)
        }
    },
    {
        Header: 'Aggregate Function',
        accessor: 'aggregateFunction',
        Cell: ({ cell, value: initialValue, row: { original, index }, column: { id, accessor } }) => {
            const { register, watch, control } = useFormContext()
            return (<>
                {convertReactSelectObjectToValue(initialValue)}
                {/* register an invisible input to allow for react hook form value tracking on a viewOnly field */}
                <input name={`columns[${index}].aggregateFunction`} ref={register()} className={`collapsedField`} defaultValue={convertReactSelectObjectToValue(initialValue)} />
            </>
            )
        }
    }
]

export default SelectColumns